export const USER_POST_RECEIVED = 'USER_POST_RECEIVED';
export const userPostReceived = (user, postId) => ({
    type: USER_POST_RECEIVED,
    user,
    postId
});